module.exports = {
      id: "comm-cinema-usage",
      viewBox: "0 0 415.94 49.818",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-cinema",
      toString: function () {
        return this.url;
      }
    }